import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import { useTheme } from '../contexts/ThemeContext';

const Layout: React.FC<{ children: React.ReactNode; userRole?: string }> = memo(({ children, userRole }) => {
  const { getThemeClasses, getThemeStyles } = useTheme();
  const location = useLocation();
  const themeClasses = getThemeClasses();
  const themeStyles = getThemeStyles();

  // Pagine che hanno layout completo interno (header + footer)
  const pagesWithInternalLayout = ['/login', '/register', '/verify', '/login/finalize'];
  const hasInternalLayout = pagesWithInternalLayout.includes(location.pathname);

  const mainStyles: React.CSSProperties = {
    position: 'relative',
    flex: 1,
    padding: hasInternalLayout
      ? '0'
      : '0 clamp(1.25rem, 4vw, 4rem) clamp(2.5rem, 6vw, 4.5rem) clamp(1.25rem, 4vw, 4rem)',
    paddingTop: hasInternalLayout ? '0' : 'calc(var(--header-height) + 2rem)',
    display: hasInternalLayout ? 'block' : 'flex',
    alignItems: hasInternalLayout ? undefined : 'stretch',
    justifyContent: hasInternalLayout ? undefined : 'center'
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: themeStyles.backgroundGradient,
        color: themeStyles.text,
        position: 'relative',
        overflow: 'hidden'
      }}
      className={`layout-shell ${themeClasses.bg} animate-fade-in`}
    >
      <div className="layout-glow layout-glow--indigo animate-float" aria-hidden="true" />
      <div className="layout-glow layout-glow--cyan animate-float" aria-hidden="true" />
      {!hasInternalLayout && <Header userRole={userRole} />}
      <main style={mainStyles} className={`layout-main ${themeClasses.text}`}>
        {hasInternalLayout ? (
          children
        ) : (
          <section
            className="layout-surface animate-fade-in-up animate-scale-in"
            style={{
              background: themeStyles.cardGlass,
              border: `1px solid ${themeStyles.border}`,
              boxShadow: themeStyles.cardShadow
            }}
          >
            {children}
          </section>
        )}
      </main>
    </div>
  );
});

Layout.displayName = 'Layout';

export default Layout;
